<template>
  <div
    :style="style_list"
    :is="tag">
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SlideUpDown',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'div'
    },
    transition_duration_seconds: {
      type: String,
      default: '.3'
    },
    overflow_prop: {
      type: String,
      default: 'hidden'
    }
  },
  data() {
    return {
      height: '',
      initialization: true,
      timeout_f: null,
    }
  },
  created() {
    if (!this.active) {
      this.height = 0
    }
  },
  mounted() {
    if (this.active) {
      setTimeout(() => {
        this.height = this.$el.scrollHeight
      })
    }
  },
  computed: {
    style_list() {
      return {
        height: `${this.height}px`,
        overflow: this.overflow_prop,
        transitionProperty: `height opacity`,
        transitionDuration: `${this.transition_duration_seconds}s`,
        opacity: this.active ? 1 : 0
      }
    }
  },
  watch: {
    active(val) {
      this.height = !val ? 0 : this.$el.scrollHeight
    }
  }
}
</script>
